export default {"src":"/_next/static/media/MonarchMoney.b43c25ae.svg","height":150,"width":920,"blurWidth":0,"blurHeight":0};